import { BuilderConfig } from '../../types/Builder';
import { COLORS } from '../business-button/business-button.constants';

import BusinessHubIndustriesBlock, { IndustriesBlockProps } from './business-hub-industries-card-block';

export const BusinessHubIndustriesCardBlockBuilderConfig = {
    name: 'Business Hub Industries Card Block',
    inputs: [
        {
            name: 'icon',
            type: 'file',
        },
        {
            name: 'iconBackground',
            type: 'color',
        },
        {
            name: 'afterpayAccessTitle',
            type: 'text',
        },
        {
            name: 'afterpayAccessTitleColor',
            type: 'color',
        },
        {
            name: 'title',
            type: 'html',
        },
        {
            name: 'description',
            type: 'html',
        },
        {
            name: 'image',
            type: 'file',
        },
        {
            name: 'imageMobile',
            type: 'file',
        },
        {
            name: 'youtubeUrl',
            type: 'link',
        },
        {
            name: 'background',
            type: 'color',
        },
        {
            name: 'textColor',
            type: 'color',
        },
        {
            name: 'ctaText',
            type: 'text',
        },
        {
            name: 'ctaUrl',
            type: 'link',
        },
        {
            name: 'ctaColor',
            type: 'string',
            enum: Object.values(COLORS),
            defaultValue: COLORS.MINT,
        },
        {
            name: 'ctaDisableBorder',
            type: 'boolean',
        },
        {
            name: 'reversed',
            type: 'boolean',
        },
    ],
};

const builderConfig: BuilderConfig<IndustriesBlockProps> = {
    component: BusinessHubIndustriesBlock,
    config: BusinessHubIndustriesCardBlockBuilderConfig,
};

export default builderConfig;
